module.exports = __webpack_public_path__ + "img/icon-no-appeals.aa33039d.svg";